import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import moment from "moment";
import CallIcon from '@mui/icons-material/Call';
import { useNavigate } from "react-router-dom";

function PendingFollowupList({ pendingFollowupData }) {
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [searchQuery, setSearchQuery] = useState(""); // Search query state

  const navigate = useNavigate();
  
  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter data based on search query
  const filteredData = pendingFollowupData.filter((data) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      data.Lot_Number?.toLowerCase().includes(searchLower) ||
      data.Farmer_Name?.toLowerCase().includes(searchLower) ||
      data.Branch_Name?.toLowerCase().includes(searchLower) ||
      data.Zone_Name?.toLowerCase().includes(searchLower) ||
      data.agent_name?.toLowerCase().includes(searchLower) ||
      data.follow_up_status?.toLowerCase().includes(searchLower)
    );
  });

  // Slice filtered data based on pagination
  const paginatedData = filteredData?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );


  const IconCell = ({ row }) => (
    <>
    

    <IconButton
      style={{
        border: "1px solid",
        borderRadius: "4px",
        padding: "2px",
        width: "24px",
        height: "24px",
        justifyContent: "center",
        alignItems: "center",
      }}
      color="primary"
      onClick={() => handleCallIconClick(row)}
    >
      <CallIcon fontSize="small" color="primary" />
    </IconButton>
    </>
  );

  

  const handleCallIconClick = (row) => {
    navigate('/dashboard', {
      state: {
        mobNo: row.Mobile,
        lotNum: row.Lot_Number
      }
    });
  };

  return (
    <Paper>
      
        {/* Search input */}
        <TextField
          label="Search"
          variant="outlined"
          size="small"
        sx={{ marginBottom: 2, margin: 1, float: 'right' }}
          value={searchQuery}
          onChange={handleSearchChange}
        />
      <TableContainer
        sx={{
          boxShadow: 2,
          borderRadius: "8px",
          margin: "16px 0",
        }}
      >
        <Table
          sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
              <TableCell align="center" sx={{ width: 50 }}>
                Sno
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Lot Number
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Farmer Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Mobile Number
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Branch Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Zone Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
              Last Action Date
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Follow-up Date
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Agent Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Status
              </TableCell>
              <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    width: "120px",
                    position: "sticky", // Make the cell sticky
                    right: 0, // Fix to the right side
                    backgroundColor: "#EEF0F4", // Set background color for visibility
                    zIndex: 100, // Higher z-index to stay above other cells
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    top: 0,
                  }}
                >
                  Action
                </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(paginatedData) && paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9}> No Data Available Yet.</TableCell>
              </TableRow>
            ) : (
              paginatedData?.map((data, index) => (
                <TableRow key={data?.id || index}>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Lot_Number || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Farmer_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Mobile || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Branch_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Zone_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {moment(data?.completed_on).format("DD-MM-YYYY") || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {moment(data?.follow_up_date).format("DD-MM-YYYY") || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.agent_name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    <Chip
                      label={data?.follow_up_status}
                      color={"error"}
                      size="small"
                      sx={{ textTransform: "capitalize", margin: "5px" }}
                    />
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      width: "120px",
                      padding: 1,
                      position: "sticky", // Make the cell sticky
                      right: 0, // Fix to the right side
                      backgroundColor: "#fff", // Set background color for visibility
                      zIndex: 10, // Higher z-index to stay above other cells
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)", // Add a shadow to the column
                    }}
                  >
                    <IconCell row={data} />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15]}
          component="div"
          count={Array.isArray(filteredData) ? filteredData.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      
    </Paper>
  );
}

export default PendingFollowupList;
